import { useMemo } from 'react';
import { useContacts } from '~/hooks/reactQuery/queries/useContacts';
export const useContactNameOptions = ()=>{
    const { contacts } = useContacts();
    return useMemo(()=>{
        const seen = new Set();
        const options = [];
        for (const contact of contacts){
            const name = contact.fullName().trim();
            if (name.length === 0 || seen.has(name)) continue;
            seen.add(name);
            options.push({
                value: name,
                label: name
            });
        }
        return options.sort((a, b)=>a.label.localeCompare(b.label));
    }, [
        contacts
    ]);
};
